import { SharedAppointmentSlotRepository } from "@/domain/repositories";
import { CreateSharedAppointmentSlotInput } from "@/domain/dtos/inputs";
import { SharedAppointmentSlot } from "@/domain/entities";
import { SharedAppointmentSlotDataSource } from "../datasources/sharedAppointmentSlots";

export class SharedAppointmentSlotRepoImpl
  implements SharedAppointmentSlotRepository
{
  constructor(
    private readonly dataSource: SharedAppointmentSlotDataSource,
  ) {}

  async createSharedAppointmentSlot(
    params: CreateSharedAppointmentSlotInput,
  ): Promise<SharedAppointmentSlot> {
    return this.dataSource.createSharedAppointmentSlot(params);
  }
}
